import type { DriveFolderRow } from './driveAccess';

/**
 * Клиентский реестр «доменно управляемых» областей Диска (coarse policy).
 *
 * Серверный lifecycle (canManageScopeFolder) расширяет право rename/move/delete
 * папки в public_write-зоне доменным правом владельца области. Клиентское меню
 * считает права локальной зонной матрицей и без этого реестра показывало бы
 * кнопки disabled там, где сервер разрешает (парадокс из код-ревью 2026-09-01).
 *
 * Политика НАМЕРЕННО грубая: «папка внутри зарегистрированной области → кнопки
 * доступны», без знания прав конкретного пользователя на конкретную сущность —
 * окончательное решение всегда за серверной авторизацией (отказ придёт понятной
 * ошибкой). Зеркалит серверную семантику ближайшего якоря: подъём до ПЕРВОЙ
 * папки с code, чужой якорь — граница.
 */

const anchorMatchers: Array<(anchorCode: string) => boolean> = [];

/** Зарегистрировать область (инстанс, в bootstrap — рядом с defineDriveActions). */
export function registerDriveDomainManagePolicy(
  matchAnchor: (anchorCode: string) => boolean
): void {
  anchorMatchers.push(matchAnchor);
}

/** Папка принадлежит зарегистрированной доменной области? (по видимому дереву) */
export function isDomainManagedFolder(
  folder: DriveFolderRow,
  foldersById: Map<number, DriveFolderRow>
): boolean {
  if (anchorMatchers.length === 0) return false;
  let current: DriveFolderRow | undefined = folder;
  const seen = new Set<number>();
  while (current && !seen.has(current.id)) {
    seen.add(current.id);
    const code = current.code;
    if (code != null && code !== '') {
      // Ближайший якорь — граница области: дальше не поднимаемся.
      return anchorMatchers.some(matches => matches(code));
    }
    current = current.parent_id != null ? foldersById.get(current.parent_id) : undefined;
  }
  return false;
}

/**
 * Сам code — якорь зарегистрированной области? Корню области структурные
 * guards запрещают move/delete (его держит системная раскладка) — меню
 * гасит эти кнопки, оставляя rename.
 */
export function isDomainManagedAnchorCode(code: string): boolean {
  return anchorMatchers.some(matches => matches(code));
}

/** Только для тестов. */
export function __clearDriveDomainManagePoliciesForTest(): void {
  anchorMatchers.length = 0;
}
